<template>
  <div class="group" :class="{ 'no-margin': noMargin }">
    <label>
      <slot></slot>
    </label>
    <span v-if="error" class="error-wrapper">
      <img class="information-icon" src="@/assets/images/icons/i_error.svg" />
      {{ error }}
    </span>
    <input v-if="mask" v-mask="mask" :value="value" :type="type" :name="name" @input="update($event.target.value)"
      :required="required" :class="{ 'invalid': error || applyErrorStyle }" />
    <input v-else :value="value" :type="type" :inputmode="inputmode" :name="name" @input="update($event.target.value)" :required="required"
      :class="{ 'invalid': error || applyErrorStyle }" />
  </div>
</template>

<script>

export default {
  name: 'BaseInput',
  props: {
    type: String,
    inputmode: String,
    name: String,
    value: [String, Number],
    required: { type: Boolean, default: true },
    error: { type: String, default: undefined },
    applyErrorStyle: Boolean || undefined,
    mask: String,
    noMargin: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    update(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:active,
input:-webkit-autofill:focus {
  background-color: #fff !important;
  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
}

.error-wrapper {
  display: flex;
  gap: 0.5rem;
  @apply text-sm mb-2;
  line-height: 18px;
  color: #AB2017;
}

.group {
  @apply relative flex flex-col;
  margin-bottom: 2rem;

  &.no-margin {
    margin-bottom: 0;
  }

  input {
    @apply w-full bg-transparent text-black px-4 block border border-grey-task text-lg;
    padding-top: 14px;
    padding-bottom: 14px;
    border-radius: 0.25rem;

    &.invalid {
      border-color: #AB2017;
      background-color: #FFEDED;
    }

    &:focus {
      @apply border-grey-3;
      outline: none;
    }
  }

  label {
    @apply mb-2 text-black-2;
  }

  .password-icon {
    @apply absolute cursor-pointer mr-3 text-grey-2;
    right: 0;
    bottom: 18px;
    transition: 0.3s;

    @media screen and (min-width: 768px) {
      bottom: 18px;

      &:hover {
        @apply text-grey-3
      }
    }
  }
}
</style>
